module.exports = __webpack_public_path__ + "42bd0e364523aafb9f00c2c11bf033d2.woff2";